import { FC } from "react";

import { Permission } from "./permissions";

import {
  Analytics,
  CoinPackages,
  Customers,
  DeliveryAreas,
  Orders,
  Roles,
  Settings,
  Transactions,
  Users,
  WaitingList,
} from "pages";

import { CustomerDetails } from "pages/Customers/View/CustomerDetails";
import { OrderDetails } from "pages/Orders/View/OrderDetails";
import { EditCreateRoles } from "pages/Roles/View/EditCreateRoles";
import { TransactionDetails } from "pages/Transactions/View/TransactionDetails";

export interface Route {
  path: string;
  Component: FC;
  access?: boolean | Permission[];
}

export const LOGIN = "/login";

export const ADMIN_ROUTES: Record<string, Route> = {
  ORDERS: {
    path: "/orders",
    Component: Orders,
    access: [Permission.OrdersGet],
  },
  ORDER_DETAILS: {
    path: "/orders/:id",
    Component: OrderDetails,
    access: [Permission.OrdersGet],
  },
  // ANALYTICS: {
  //   path: "/analytics",
  //   Component: Analytics,
  //   access: [Permission.StatisticsGet],
  // },
  CUSTOMERS: {
    path: "/customers",
    Component: Customers,
    access: [Permission.CustomersGet],
  },
  CUSTOMERS_DETAILS: {
    path: "/customers/:id",
    Component: CustomerDetails,
    access: [Permission.CustomersGet, Permission.CustomerBase],
  },
  COIN_PACKAGES: {
    path: "/coin-packages",
    Component: CoinPackages,
    access: true,
  },
  TRANSACTIONS: {
    path: "/transactions",
    Component: Transactions,
    access: [Permission.TransactionsGet],
  },
  //TODO: remove comment if BE is ready
  // TRANSACTIONS_DETAILS: {
  //   path: "/transactions/:id",
  //   Component: TransactionDetails,
  //   access: [Permission.TransactionsGet],
  // },
  USERS: {
    path: "/users/all-users",
    Component: Users,
    access: [Permission.UsersGet],
  },
  WAITING_LIST: {
    path: "/users/waiting-list",
    Component: WaitingList,
    access: [Permission.UsersGet],
  },
  ROLES: {
    path: "/roles",
    Component: Roles,
    access: [Permission.RolesGet],
  },
  ROLES_CREATE: {
    path: "/roles/create",
    Component: EditCreateRoles,
    access: [Permission.RolesCreate],
  },
  ROLES_EDIT: {
    path: "/roles/:id",
    Component: EditCreateRoles,
    access: [Permission.RolesUpdate],
  },
  // DELIVERY_AREAS: {
  //   path: "/delivery-areas",
  //   Component: DeliveryAreas,
  //   access: [Permission.LocationsGet],
  // },
  SETTINGS: {
    path: "/settings",
    Component: Settings,
    access: [Permission.SettingsGet],
  },
};
